import { useNavigate } from 'react-router-dom';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Button, ButtonGroup, InputGroup } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import HeaderQuoteAi from './headerQuoteAi';
import SidebarQuoteAi from '../quote/sidebarQuoteAi';
import RightHeaderPage from './rightHeader';

const RatingInformationPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <div id="quoteAi">
        <HeaderQuoteAi />
        <div className="QuoteDashboard">
          <div className="main">
            <div className="pageformBloack">
              <div className=" container-fluid ">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sidebar-visible">
                      <SidebarQuoteAi />
                    </div>
                  </div>

                  <div className="col-12 col-md-12 col-lg-8 gx-2 main-quotescroll">
                    <div className="whiteBoxCont ">
                      <div className="quote_buttongroup">
                        <div className="form_action_buttons mb-2">
                          <ButtonGroup>
                            <Button
                              variant="outline-back"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/PreQualifierQuestionPage')}
                            >
                              Back
                            </Button>
                            <Button
                              variant="outline-next"
                              className="button-gap"
                              onClick={() => navigate('/quoteAI/DeductiblePage')}
                            >
                              Next
                            </Button>
                          </ButtonGroup>
                          <ButtonGroup>
                            <Button variant="outline-cancel" className="button-gap">
                              Cancel
                            </Button>
                            <Button variant="primary-save" className="button-gap">
                              Save
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="scrollable-content">
                        <div className="formcard-container mrgTop ">
                          {/* Insured Information Section */}
                          <Card className="mb-4 formpage-card">
                            <Card.Header className="formpage-card-header">
                              Rating Information
                            </Card.Header>
                            <Card.Body>
                              <div className="section-background">
                                <Row>
                                  <h4 className="step-header">Policy Limits</h4>

                                  {/* Policy Limit - Each Accident */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Policy Limit - Each Accident</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>

                                  {/* Policy Limit - Disease */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Policy Limit - Disease</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>

                                  {/* Limit - Disease (Each Employee) */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Limit - Disease (Each Employee)</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                              <div className="section-background">
                                <Row>
                                  <h4 className="step-header">Policy Information</h4>

                                  {/* Policy Limit - Each Accident */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Policy Limit - Each Accident</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>

                                  {/* Policy Limit - Disease */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Policy Limit - Disease</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>

                                  {/* Limit - Disease (Each Employee) */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Limit - Disease (Each Employee)</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                              <div className="section-background">
                                <Row>
                                  <h4 className="step-header">Coverages</h4>

                                  {/* Managed Care Radio Selection */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Managed Care</Form.Label>
                                      <Row className="value-label-row">
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="yes-radio"
                                            name="managed-care-radio" // Updated name based on label
                                          />
                                          <Form.Label htmlFor="yes-radio" className="mb-0">
                                            Yes
                                          </Form.Label>
                                        </Col>
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="no-radio"
                                            name="managed-care-radio" // Updated name based on label
                                          />
                                          <Form.Label htmlFor="no-radio" className="mb-0">
                                            No
                                          </Form.Label>
                                        </Col>
                                        <Col xs={12} sm={12} md={12}>
                                          <Form.Group className="form-section-group mt-2">
                                            <Form.Label>Other Coverage</Form.Label>
                                            <InputGroup>
                                              <InputGroup.Text>$</InputGroup.Text>
                                              <Form.Control
                                                type="number"
                                                placeholder="Enter amount"
                                                min="0"
                                                step="0.01"
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </Form.Group>
                                  </Col>

                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Voluntary Comp</Form.Label>
                                      <Row className="value-label-row">
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="yes-radio"
                                            name="voluntary-comp-radio" // Updated name based on label
                                          />
                                          <Form.Label htmlFor="yes-radio" className="mb-0">
                                            Yes
                                          </Form.Label>
                                        </Col>
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="no-radio"
                                            name="voluntary-comp-radio" // Updated name based on label
                                          />
                                          <Form.Label htmlFor="no-radio" className="mb-0">
                                            No
                                          </Form.Label>
                                        </Col>
                                        <Col xs={12} sm={12} md={12}>
                                          <Form.Group className="form-section-group mt-2">
                                            <Form.Label>Other Coverage</Form.Label>
                                            <InputGroup>
                                              <InputGroup.Text>$</InputGroup.Text>
                                              <Form.Control
                                                type="number"
                                                placeholder="Enter amount"
                                                min="0"
                                                step="0.01"
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </Form.Group>
                                  </Col>

                                  {/* U.S. L&H Radio Selection */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>U.S. L&H</Form.Label>
                                      <Row className="value-label-row">
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="yes-radio"
                                            name="us-lh"
                                          />
                                          <Form.Label htmlFor="yes-radio" className="mb-0">
                                            Yes
                                          </Form.Label>
                                        </Col>
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="no-radio"
                                            name="us-lh"
                                          />
                                          <Form.Label htmlFor="no-radio" className="mb-0">
                                            No
                                          </Form.Label>
                                        </Col>
                                      </Row>
                                    </Form.Group>
                                    <Form.Group className="form-section-group mt-3">
                                      <Form.Label>Foreign Coverage</Form.Label>
                                      <Row className="value-label-row">
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="yes-radio"
                                            name="foreign-coverage-radio" // Updated name based on label
                                          />
                                          <Form.Label htmlFor="yes-radio" className="mb-0">
                                            Yes
                                          </Form.Label>
                                        </Col>
                                        <Col
                                          xs={12}
                                          sm={2}
                                          md={2}
                                          lg={3}
                                          className="d-flex align-items-center"
                                        >
                                          <Form.Check
                                            type="radio"
                                            className="me-2"
                                            id="no-radio"
                                            name="foreign-coverage-radio" // Updated name based on label
                                          />
                                          <Form.Label htmlFor="no-radio" className="mb-0">
                                            No
                                          </Form.Label>
                                        </Col>
                                      </Row>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                              <div className="section-background">
                                <Row>
                                  <h4 className="step-header">Other Factors</h4>

                                  {/* Exp. Mod Factor */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Exp. Mod Factor</Form.Label>
                                      <Form.Control
                                        type="number"
                                        placeholder="Enter Exp. Mod Factor"
                                      />
                                    </Form.Group>
                                  </Col>

                                  {/* Exp. Mod Date */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Exp. Mod Date</Form.Label>
                                      <Form.Control
                                        type="date"
                                        placeholder="Select Exp. Mod Date"
                                      />
                                    </Form.Group>
                                  </Col>

                                  {/* Risk ID */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Risk Id</Form.Label>
                                      <Form.Control type="text" placeholder="Enter Risk ID" />
                                    </Form.Group>
                                  </Col>

                                  {/* Exp. Mod Factor */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>FELA</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>

                                  {/* Waiver of Subrogation */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Waiver of Subrogation</Form.Label>
                                      <Form.Select>
                                        <option value="">Select Waiver of Subrogation</option>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>

                                  {/* Waiver Amount */}
                                  <Col xs={12} sm={12} md={6} lg={4} className="mb-2">
                                    <Form.Group className="form-section-group">
                                      <Form.Label>Waiver Amount</Form.Label>
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter amount"
                                          min="0"
                                          step="0.01"
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-2">
                    <div className="sticky-right-top">
                      <RightHeaderPage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RatingInformationPage;
